export default __webpack_public_path__ + "static/char-v-43-33c1aa85be8051133eb4ea8cfaacc3ee.png";